import { render } from "./RelatedSoftwareSection.vue?vue&type=template&id=320f927a"
import script from "./RelatedSoftwareSection.vue?vue&type=script&lang=js"
export * from "./RelatedSoftwareSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__